// Chakra imports
import {
  Avatar,
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
  Link as ChakraLink,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useNavigate, Link as ReactRouterLink } from 'react-router-dom';

const Header = ({
  BackUrl,
  backgroundHeader,
  backgroundProfile,
  avatarImage,
  name,
  email,
  tabs,
  isLink,
  isSubHeaderLink,
  link,
  subHeaderLink,
}) => {
  // Chakra color mode
  const textColor = useColorModeValue('gray.700', 'white');
  const borderProfileColor = useColorModeValue(
    'white',
    'rgba(255, 255, 255, 0.31)'
  );
  const emailColor = useColorModeValue('gray.400', 'gray.300');
  const navigate = useNavigate();
  const trigger = useRef(false);

  const goBack = () => {
    if (!trigger.current) {
      trigger.current = true;

      if (BackUrl) {
        navigate(BackUrl, { replace: true });
      } else {
        navigate(-1);
      }
    }
  };

  return (
    <Box
      mb={{ sm: '205px', md: '30px', xl: '70px' }}
      borderRadius="15px"
      px="0px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      align="center"
    >
      <Box
        bgImage={backgroundHeader}
        w="100%"
        h="200px"
        borderRadius="25px"
        bgPosition="50%"
        bgRepeat="no-repeat"
        position="relative"
        display="flex"
        justifyContent="center"
      >
        <Flex
          direction={{ sm: 'column', md: 'row' }}
          mx="1.5rem"
          maxH="130px"
          w={{ sm: '90%', xl: '95%' }}
          justifyContent={{ sm: 'center', md: 'space-between' }}
          align="center"
          backdropFilter="saturate(200%) blur(50px)"
          position="absolute"
          boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
          border="2px solid"
          borderColor={borderProfileColor}
          bg={backgroundProfile}
          borderRadius="20px"
          transform={{
            sm: 'translateY(45%)',
            md: 'translateY(110%)',
            lg: 'translateY(160%)',
          }}
        >
          <Flex
            align="center"
            mb={{ sm: '10px', md: '0px' }}
            direction={{ sm: 'column', md: 'row' }}
            w={{ sm: '100%' }}
            textAlign={{ sm: 'center', md: 'start' }}
          >
            <Avatar
              me={{ md: '22px' }}
              src={avatarImage}
              w="80px"
              h="80px"
              borderRadius="15px"
            />
            <Flex direction="column" maxWidth="100%" my={{ sm: '14px' }}>
              <Text
                fontSize={{ sm: 'lg', lg: 'xl' }}
                color={textColor}
                fontWeight="bold"
                ms={{ sm: '8px', md: '0px' }}
              >
                {isLink && (
                  <ChakraLink color="teal.500" as={ReactRouterLink} to={link}>
                    {name}
                  </ChakraLink>
                )}
                {!isLink && name}
              </Text>
              <Text
                fontSize={{ sm: 'sm', md: 'md' }}
                color={emailColor}
                fontWeight="semibold"
              >
                {isSubHeaderLink && (
                  <ChakraLink
                    color="teal.500"
                    as={ReactRouterLink}
                    to={subHeaderLink}
                  >
                    {email}
                  </ChakraLink>
                )}
                {!isSubHeaderLink && email}
              </Text>
            </Flex>
          </Flex>
          <Flex
            direction={{ sm: 'column', lg: 'row' }}
            w={{ sm: '100%', md: '50%', lg: 'auto' }}
          >
            <Button
              p="0px"
              bg="transparent"
              _hover={{ bg: 'none' }}
              onClick={goBack}
            >
              <Flex
                align="center"
                w={{ lg: '135px' }}
                borderRadius="15px"
                justifyContent="center"
                py="10px"
                cursor="pointer"
              >
                {tabs[0].icon}
                <Text
                  fontSize="xs"
                  color={textColor}
                  fontWeight="bold"
                  ms="6px"
                >
                  {tabs[0].name}
                </Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Header;
